;(function($){var ajax = (p, c, e) => { $.ajax({url: window.location.href, method: "POST",							data: $.extend(true, p !== undefined && typeof p == "object" ? p : {}, {								action: "layouthub_section_ajax", section_id: "cOd4p8MLGY"							}), success: c, error: e});						}, cb  = function(section, $) {;var cb  = function($) {
    function loadGoogleMaps() {
        if(section.settings.map_api != ''){
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                var mapScript = document.createElement('script');
                mapScript.src = "https://maps.googleapis.com/maps/api/js?key=" + section.settings.map_api;
                document.head.appendChild(mapScript);
            }
        }
    }

    loadGoogleMaps();

    function initMap() {
          var myLatLng = {
            lat: parseFloat(section.settings.map_lat),
            lng: parseFloat(section.settings.map_lng)
          };

          var map = new google.maps.Map(document.getElementById('map'), {
            zoom: parseInt(section.settings.map_zoom),
            center: myLatLng,
          });

          var infoString = '<div class="lh-infowindow">'+ section.settings.map_info_box +'</div>';

          var infowindow = new google.maps.InfoWindow({
            content: infoString
          });

          var iconMarker = 'https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/Pe4MB6IC1TF5cpOQ/contact/assets/images/mapker.svg';
          if(section.settings.map_marker != ''){
            iconMarker = section.settings.map_marker;
          }

          var markerArgs = {
            position: myLatLng,
            map: map,
            icon: iconMarker,
            visible: true
          };

          if(section.settings.map_show_marker == 'no'){
            markerArgs.visible = false;
          }

          var marker = new google.maps.Marker(markerArgs);

          if(section.settings.map_style == 'style_2'){
            var customStyled = [{"elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","stylers":[{"visibility":"off"}]},{"featureType":"administrative.neighborhood","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","stylers":[{"visibility":"off"}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#e9fefd"},{"saturation":-35},{"lightness":10},{"weight":1.5}]}];
            map.set('styles', customStyled);
          }
          if(section.settings.map_style == 'style_3'){
            var customStyled = [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#6e6e6e"}]},{"featureType":"administrative.country","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"administrative.locality","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"administrative.neighborhood","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f4f4f4"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"all","stylers":[{"visibility":"simplified"},{"color":"#d2ef9d"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#94dfed"},{"visibility":"on"}]}];
            map.set('styles', customStyled);
          }

          if(section.settings.map_show_marker == 'yes'){
            marker.addListener('click', function() {
                infowindow.open(map, marker);
            });
          }

          if(section.settings.map_show_infobox == 'yes' || (section.settings.map_show_marker == 'no' && section.settings.map_show_infobox == 'yes')){
              google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                infowindow.open(map, marker);
              });
          }

          if(section.settings.map_show_marker == 'no' && section.settings.map_show_infobox == 'yes'){
              google.maps.event.addListenerOnce(map, 'tilesloaded', function() {
                  $('.lh-google-map-section').addClass('lh-hide-close-infobox');
              });
          }

          return map;
    }

    var timerLoadMap = setInterval(funcCheckLoadMap, 50);

    function funcCheckLoadMap(){
        if (typeof google === 'object' && typeof google.maps === 'object') {
            initMap();
            clearInterval(timerLoadMap);
        }
    }
 };						cb.bind($('section[data-section-id="cOd4p8MLGY"]').get(0))(jQuery);};					cb.bind($('section[data-section-id="cOd4p8MLGY"]').get(0))({						url: "https://library.layouthub.com/HUB/files/TWF5LS0yMDIw/NTkwNDU2ODky/twenty-twenty-summer/pages/Pe4MB6IC1TF5cpOQ/contact/",						settings: {"map_api":"","map_lat":"","map_lng":"","map_zoom":"1","map_info_box":"<p><strong>Saint-Petersburg,</strong></p><p><strong>191186 Millionnaya st. 29</strong></p><p>hello@greatsimple.com<br></p><p>+1 222-345-0000<br></p><!--lh-live-editor-->","map_marker":"","map_show_marker":"yes","map_style":"style_3","map_show_infobox":"no"}					}, jQuery);})(jQuery);;console.log('This page layout has been built by https://www.layouthub.com');window.addEventListener("load",()=>{let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 15px","width: 100%","text-align: center","opacity: 1","z-index: 10000000000000000","text-indent: 0","color: #333","background: #fff",""].join(" !important;")),b.innerHTML="Page layout provided by &hearts; <a href=\"https://www.layouthub.com/?utm_source=client-site&utm_medium=footer&utm_campaign=freemium&utm_term=links&utm_content="+window.location.origin+"\">Layouthub.com</a>",a.appendChild(b)});